import type { EcommercePartialItem } from '../../../../../types/analytics/ECommerce';
import type { Variant } from '../../../../../types/CoreShoppingExperience';

const convertPartialProductToItem = (variant: Variant, variantIndex: number): EcommercePartialItem => {
  return {
    itemName: variant.upgradeType,
    index: variantIndex,
    itemBrand: variant.textKey,
    upgradeType: variant.upgradeType,
    fromCabin: variant.fromCabin,
  };
};

export default convertPartialProductToItem;
